import React, {useEffect} from 'react';
import Breadcrumbs from "../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {ProgramDetailBlock} from './components/ProgramDetailBlock';
import './styles/app.scss';
import fetch from "isomorphic-unfetch";

const items = [
  {
    label: "Каталог образовательных программ",
    link: "/work/app/catalog"
  },
];

const useStyles = makeStyles({
  root: {
    height: '100vh',
  },
});

class CatalogProgramView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popup: null,
            programId: null,
            programDetail: null
        }
    }

    loadDetail = () => {
        let programId = this.props.match.params['id'];
        fetch("https://copp72.ru/api/site/program/" + programId + "/detail")
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 404) {
                    this.props.history.push("/programs")
                } else {
                    throw response;
                }
            })
            .then(json => {
                this.setState({
                    programId: programId,
                    programDetail: json,
                })
            })
    };

    componentDidMount() {
        this.loadDetail();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params['id'] !== this.state.programId) {
            this.loadDetail();
        }
    }

    handlePopupAdd = popup => {
        this.setState({popup});
    };

    handlePopupRemove = () => {
        this.setState({popup: null})
    };

    render(){
      return (
        <div>
          <Breadcrumbs items={items} />
          <div>
            {this.state.programDetail &&
                <><ProgramDetailBlock initialState={this.state.programDetail}/>
                 </>}
          </div>
        </div>
      );
    }
};

export default CatalogProgramView;
